<div
  class="be-form-group-container"
  [ngClass]="{ 'be-form-group-container--sm': variant() === 'sm' }"
  [formGroup]="beFormGroup()"
  >
  <label
    class="be-input-label"
    [ngClass]="
      beFormControl().invalid && beFormControl().touched
        ? 'be-input-label-error'
        : ''
    "
    [for]="beFormControlName()"
    >
    {{ inputLabel() }}
  </label>

  <div
    class="be-input-container"
    [ngClass]="
      beFormControl().invalid && beFormControl().touched
        ? 'be-input-container-error'
        : ''
    "
    >
    <ng-content select="[icon]"></ng-content>

    <input
      #input
      [type]="effectiveInputType()"
      [attr.inputmode]="inputMode()"
      [id]="beFormControlName()"
      [attr.name]="inputName() ?? null"
      class="be-input"
      [ngClass]="isHiddenTogglable() ? 'fs-exclude' : ''"
      [attr.aria-describedby]="
        describedBy()
          ? describedBy()
          : hint() && (beFormControl().valid || beFormControl().untouched)
            ? hintId()
            : requiredError() &&
                beFormControl().hasError('required') &&
                beFormControl().touched
              ? requiredErrorId()
              : detailError() &&
                  beFormControl().invalid &&
                  beFormControl().touched
                ? detailErrorId()
                : null
      "
      [placeholder]="inputPlaceholder()"
      [formControlName]="beFormControlName()"
      [attr.maxlength]="inputMaxLength() || null"
      [mask]="maskValue()"
      [patterns]="patternsValue()"
      [specialCharacters]="specialCharactersValues()"
      thousandSeparator=","
      [hiddenInput]="isHiddenInput() && inputType() !== 'password'"
      [autocomplete]="autocompleteValue()"
      (focusout)="onFocusLoss()"
      (focus)="onFocus.emit()"
      />

    <!-- Visibility Toggle -->
    @if (isHiddenTogglable()) {
      <button
        type="button"
        class="btn-nude icon-password-container"
        (mousedown)="$event.preventDefault()"
        (click)="toggleTextVisibility()"
        [attr.aria-label]="isHiddenInput() ? 'Show password' : 'Hide password'"
        [attr.aria-pressed]="!isHiddenInput()"
        >
        <svg
          viewBox="0 0 100 100"
          class="icon-password"
          aria-isHiddenInput="true"
          >
          @if (isHiddenInput()) {
            <use
              href="assets/icons-v2/sprites.svg#eye-off"
            ></use>
          }
          @if (!isHiddenInput()) {
            <use
              href="assets/icons-v2/sprites.svg#eye"
            ></use>
          }
        </svg>
      </button>
    }
  </div>

  <!-- hint if applicable; hides when error is present -->
  @if (hint() && (beFormControl().valid || beFormControl().untouched)) {
    <app-be-helper-text
      [helperId]="hintId()"
      >
      {{ hint() }}
    </app-be-helper-text>
  }

  <!-- required error if applicable  -->
  @if (
    requiredError() &&
    beFormControl().hasError('required') &&
    beFormControl().touched
    ) {
    <app-be-helper-text
      helperType="error"
      [helperId]="requiredErrorId()"
      >
      {{ requiredError() }}
    </app-be-helper-text>
  }

  <!-- detailed error msgs if applicable-->
  @if (
    detailError() &&
    beFormControl().invalid &&
    !beFormControl().hasError('required') &&
    beFormControl().touched
    ) {
    <app-be-helper-text
      helperType="error"
      [helperId]="detailErrorId()"
      >
      {{ detailError() }}
    </app-be-helper-text>
  }

  <!-- content projection for additional error handling -->
  <ng-content></ng-content>
</div>
